/* Calendar dates use Japan time, irrespective of the customer's time zone. */
(function (root) {
  function minimumDate(now = new Date()) {
    const date = new Date(now.getTime() + 9 * 60 * 60 * 1000);
    date.setUTCDate(date.getUTCDate() + 3);
    return date.toISOString().slice(0, 10);
  }
  const api = { minimumDate };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.DhuniDeliveryCalendar = api;
})(typeof window !== 'undefined' ? window : globalThis);
